import { Donor } from './donor';

export class MakePayment {
    idempotentKey: string;
    campaignId: number;
    paymentMethodType: string;
    paymentMethodToken: string;
    amount: number;
    fee: number;
    donor: Donor;
    isTestCreditCard: boolean;
    isPrivate: boolean;
}
